var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-options" },
    [
      _c(
        "PageHeaderOptions",
        {
          attrs: {
            allowChangePIC: _vm.allowChangePIC,
            allowCancel: _vm.allowCancel,
            showSubstitute: _vm.allowResetToDraft,
            previousPersonInCharge: _vm.currentPersonInCharge,
            confirmCancelMsg: _vm.cancelMsg(),
            itemName: _vm.tenderType(),
            site: _vm.site,
            ignoredSiteUsernames: [
              _vm.deep(_vm.currentTender, "general.approver.username"),
              _vm.deep(_vm.currentTender, "general.manager.username"),
            ],
          },
          on: {
            "change-pic": function (val) {
              return _vm.changePIC(val)
            },
            cancelItem: function ($event) {
              return _vm.cancelTender()
            },
          },
        },
        [
          _vm.allowResetToDraft
            ? _c(
                "li",
                { attrs: { slot: "substitute" }, slot: "substitute" },
                [
                  _c(
                    "DialogSlot",
                    {
                      ref: "resetToDraft-modal",
                      attrs: {
                        id: "tender-reset-to-draft-dialog",
                        modalBtnClass: "btn--transparent",
                        modalBtn: _vm.$t("action.resetToDraft"),
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "slot-content",
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _c("span", { staticClass: "font-bold" }, [
                            _vm._v(_vm._s(_vm.$t("hint.resetTenderToDraft"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { slot: "buttons" }, slot: "buttons" },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                { name: "hkldreset", rawName: "v-hkldreset" },
                              ],
                              staticClass: "btn btn--orange close-reveal-modal",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetToDraft()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }